import React from 'react';
import { motion } from 'framer-motion';
import { Activity, BatteryWarning, Flame } from 'lucide-react';
export function PainSection() {
  return <section className="py-12 md:py-32 bg-warm-beige relative" data-id="element-98">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8 md:mb-16" data-id="element-100">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-deep-charcoal mb-5 md:mb-8 leading-tight" data-id="element-101">
            ¿Te ha pasado que una semana te sientes invencible en el gimnasio y
            a la siguiente te levantas hinchada, sin energía y con antojos
            incontrolables de dulce?
          </h2>

          <div className="w-24 h-1 bg-sage-green mx-auto mb-6 md:mb-12 rounded-full" data-id="element-102"></div>

          <p className="text-xl md:text-2xl font-medium text-dusty-rose mb-8" data-id="element-103">
            No estás loca. No eres perezosa. Eres una mujer con un ciclo de 28
            días intentando vivir en un mundo diseñado para un ciclo de 24
            horas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-104">
          {[{
          icon: <Flame className="w-8 h-8 text-dusty-rose" data-id="element-105" />,
          title: 'Modo Supervivencia',
          desc: 'Cuando entrenas pesado en la fase equivocada, tu cuerpo se estresa.'
        }, {
          icon: <Activity className="w-8 h-8 text-dusty-rose" data-id="element-106" />,
          title: 'Picos de Cortisol',
          desc: 'El estrés eleva el cortisol, bloqueando tu capacidad natural de quemar grasa.'
        }, {
          icon: <BatteryWarning className="w-8 h-8 text-dusty-rose" data-id="element-107" />,
          title: 'Grasa Abdominal',
          desc: 'Tu cuerpo almacena grasa para protegerse de lo que percibe como una amenaza.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-cream-white text-center" data-id="element-108">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto bg-soft-pink rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-109">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-deep-charcoal mb-3" data-id="element-110">
                {item.title}
              </h3>
              <p className="text-deep-charcoal/70" data-id="element-111">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center" data-id="element-112">
          <p className="text-xl text-deep-charcoal font-medium bg-white/50 inline-block px-8 py-4 rounded-xl border border-sage-green/30" data-id="element-113">
            Es hora de dejar de adivinar y empezar a sincronizar.
          </p>
        </motion.div>
      </div>
    </section>;
}